import { cn } from "@/lib/utils";

/**
 * Standard page header. Replaces the repeated heading + subheading +
 * inline marginBottom pattern across Dashboard, ReportFolders, Usage, Billing, etc.
 *
 * Usage:
 *   <PageHeader title="My Report Folders" />
 *   <PageHeader title="My Report Folders" subtitle="Manage your Report Folders and students." />
 *   <PageHeader
 *     title="My Report Folders"
 *     subtitle="Manage your Report Folders."
 *     action={<Button onClick={...}>+ New Report Folder</Button>}
 *   />
 */
function PageHeader({ title, subtitle, action, className }) {
  return (
    <div className={cn("mb-8", className)}>
      <h1 className="font-display text-4xl font-normal text-foreground leading-tight">
        {title}
      </h1>
      {subtitle && (
        <p className="mt-2 text-base font-sans text-muted-foreground leading-relaxed">
          {subtitle}
        </p>
      )}
      {action && (
        <div className="mt-4 flex flex-wrap items-center justify-end gap-2">
          {action}
        </div>
      )}
    </div>
  );
}

export { PageHeader };
